<script lang="ts">
  import Tile from '~/board/Tile.svelte';
  import Star from '~/icons/Star.svelte';
  import { getGame } from '~/store/GameContext.svelte';
  import { prettyDate } from '~/utils/dates';
  import GjLink from './GJLink.svelte';
  import type { Match } from '~/types';
  import { DailyGame } from '~/store/daily.svelte';

  const game = $derived(getGame<DailyGame>().current);
  type Props = {
    words: Match[];
  };
  const props: Props = $props();
</script>

<div class="container">
  <div class="words">
    {#each props.words as word}
      <div class="word">
        {#each word.word as _letter}
          <Tile
            size="share"
            highlighted={word.axis === 'col'
              ? 'daily-vertical'
              : 'daily-horizontal'}
            tile={{ id: '', letter: '' }}
          />
        {/each}
      </div>
    {/each}
  </div>
  <div class="leftovers">
    <div class="board">
      {#each game.finalBoard ?? [] as row}
        <div class="row">
          {#each row as tile}
            <Tile
              size="share"
              highlighted="red"
              tile={{ id: tile.id, letter: tile.letter }}
            />
          {/each}
        </div>
      {/each}
    </div>
  </div>
  <div class="stars">
    <div class="stars-inner">
      {#each Array.from({ length: game.stars ?? 0 }) as _star, i}
        <Star
          outlined
          size="96px"
          class={i < (game.stars ?? 0) - 1
            ? 'yellow'
            : game.fullClear
              ? 'green'
              : 'yellow'}
        />
      {/each}
    </div>
    <span class="date">
      {prettyDate(game.date)?.slice(0, -6)}
    </span>
  </div>
  <div class="link-container">
    <GjLink />
  </div>
</div>

<style lang="scss">
  @use '../theme/theme';
  .container {
    position: relative;
    height: 100%;
    width: 100%;
  }
  .words {
    position: absolute;
    display: flex;
    flex-direction: row;
    align-items: end;
    gap: 16px;
    margin-top: auto;
    bottom: 0;
    left: 0;
  }
  .leftovers {
    position: absolute;
    display: flex;
    flex-direction: row;
    align-items: end;
    bottom: 32px;
    right: 16px;
  }
  .word {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .board {
    display: flex;
    flex-direction: row;
    gap: 8px;
    & .row {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  }
  .stars {
    overflow: visible;
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: end;
    flex-direction: column;
  }
  .stars-inner {
    display: flex;
    padding-bottom: 12px;
    gap: 8px;
  }
  .date {
    font-weight: bold;
    font-size: 48px;
    padding-right: 8px;
  }
  .link-container {
    position: absolute;
    bottom: -108px;
    right: 0;
  }
</style>
